import React from "react"

const ThankYou = () => {
    return (
        <section className="thankyou">
            <div className="wrapper">
                <p>Thank you for your order!</p>
                <p>We have sent you a confirmation email. It might end up in your "Promotions" tab instead of your default "Inbox"</p>
            </div>
        </section>
    )
}

export default ThankYou
